import { useTopPostsControls } from './useTopPostsControls.hook';
import DrawerSectionHeading from '../DrawerSectionHeading';
import SortableTopPosts from './SortableTopPosts';
import Stack from '../Stack';
import { TikTokIcon } from '../Icons';
import TopPostsDownloadButton from './TopPostsDownloadButton';
import { useCurrentCountry } from 'utils/hooks';
import { useTikTokRelatedDrawerTopPosts } from 'utils/hooks/api';

function TopPostsDrawer({
    year,
    week,
    countryId,
    parentEntity,
    parentEntityId,
    relatedType,
    selectedId,
    displayQty = 5,
    name,
}) {
    const country = useCurrentCountry();
    const {
        sortSelect,
        value,
        defaultSortOption,
        visibleOrderedMetrics,
        columnsMenu,
    } = useTopPostsControls({
        week,
        year,
        mixpanelContext: 'TopPostsSortSelect',
        tableName: 'top-posts-section-card',
    });
    // Keyword-matching cutover: read from the new
    // `tiktok_data_store_*_top_posts` tables. The legacy
    // `useTopPostsRelatedEntities` hit the dropped related-hashtag tables.
    const enabled = !!(countryId && selectedId && parentEntity && week && year);
    const topPostsQuery = useTikTokRelatedDrawerTopPosts({
        entity: relatedType,
        year: value.year,
        week: value.week,
        rank_type: value.apiRankType,
        countries: countryId ? [countryId] : null,
        categories: parentEntity?.type === 'category' ? [parentEntityId] : null,
        brands: parentEntity?.type === 'brand' ? [parentEntityId] : null,
        relatedCategories: relatedType === 'category' ? [selectedId] : null,
        relatedBrands: relatedType === 'brand' ? [selectedId] : null,
        enabled,
    });

    return (
        <Stack $space="1rem">
            <DrawerSectionHeading>
                <span css="display: flex; align-items: center; gap: .5rem;">
                    <TikTokIcon />
                    Top Posts
                </span>
                <span css="margin-left: auto;">
                    <TopPostsDownloadButton
                        year={value.year}
                        week={value.week}
                        name={name}
                        country={country}
                        source="tiktok"
                        topPostsQuery={topPostsQuery}
                        visibleOrderedMetrics={visibleOrderedMetrics}
                    />
                </span>
            </DrawerSectionHeading>
            <Stack
                css="display: flex; justify-content: space-between;"
                $space=".25rem"
                $direction="row"
            >
                {sortSelect}
                {columnsMenu}
            </Stack>
            <SortableTopPosts
                topPostsQuery={topPostsQuery}
                displayQty={displayQty}
                sortOption={defaultSortOption}
                visibleOrderedMetrics={visibleOrderedMetrics}
            />
        </Stack>
    );
}

export default TopPostsDrawer;
